export default __webpack_public_path__ + "static/logo_shadow-d5f3caafe2eb95ff9184fd9c2c5b66f2.png";